"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HeaderTop = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _styles = require("./styles");

var _index = require("../../atoms/ScreenHeader/index");

var _index2 = require("../../atoms/GeneralButton/index");

var _react = require("react");

var _Chat = require("../../organisms/Chat");

var _IconoAB = _interopRequireDefault(require("../../../../src/assets/images/generalButton/Icono AB.svg"));

var _react2 = require("@testing-library/react");

var _jsxRuntime = require("react/jsx-runtime");

var HeaderTop = function HeaderTop(_ref) {
  var setHeaderTop = _ref.setHeaderTop,
      withChat = _ref.withChat,
      chatType = _ref.chatType,
      productSelected = _ref.productSelected,
      token = _ref.token,
      auditableVersion = _ref.auditableVersion,
      setCompare = _ref.setCompare,
      isAuditor = _ref.isAuditor,
      activeRetailer = _ref.activeRetailer;
  var headerTop = (0, _react.useRef)();

  var _useState = (0, _react.useState)(null),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      chat = _useState2[0],
      setChat = _useState2[1];

  var _useState3 = (0, _react.useState)(null),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      chatData = _useState4[0],
      setChatData = _useState4[1];

  (0, _react.useEffect)(function () {
    if (activeRetailer.id && productSelected && token.length) {
      var _productSelected$arti;

      setChatData({
        id: (productSelected === null || productSelected === void 0 ? void 0 : (_productSelected$arti = productSelected.article) === null || _productSelected$arti === void 0 ? void 0 : _productSelected$arti.id_article) || (productSelected === null || productSelected === void 0 ? void 0 : productSelected.id_article),
        version: productSelected === null || productSelected === void 0 ? void 0 : productSelected.version,
        retailerId: activeRetailer === null || activeRetailer === void 0 ? void 0 : activeRetailer.id,
        status: productSelected === null || productSelected === void 0 ? void 0 : productSelected.status,
        userToken: token
      });
    }
  }, [activeRetailer, productSelected, token]);
  (0, _react.useEffect)(function () {
    if (chatType) renderChat(chatType);
  }, [chatData, chatType]);
  (0, _react.useEffect)(function () {
    setHeaderTop && setHeaderTop(headerTop.current.clientHeight);
  }, []);

  var renderChat = function renderChat(chatType) {
    switch (chatType) {
      case "product_status":
        chatData && setChat( /*#__PURE__*/(0, _jsxRuntime.jsx)(_Chat.Chat, {
          chatType: "product_status",
          chatContainerType: "popUp",
          chatData: {
            id: chatData === null || chatData === void 0 ? void 0 : chatData.id,
            version: chatData === null || chatData === void 0 ? void 0 : chatData.version,
            retailerId: chatData === null || chatData === void 0 ? void 0 : chatData.retailerId,
            status: chatData === null || chatData === void 0 ? void 0 : chatData.status,
            userToken: chatData === null || chatData === void 0 ? void 0 : chatData.userToken
          },
          size: 18,
          activeRetailer: activeRetailer
        }));
        break;

      default:
        setChat( /*#__PURE__*/(0, _jsxRuntime.jsx)(_Chat.Chat, {
          chatType: "merchant_product",
          chatContainerType: "popUp",
          chatData: {
            userToken: token,
            id: productSelected.id_article,
            version: productSelected.version
          },
          size: 18,
          activeRetailer: activeRetailer
        }));
        break;
    }
  };

  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Container, {
    ref: headerTop,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_index.ScreenHeader, {
      text: "Edici\xF3n de producto"
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "buttons-container",
      children: [withChat && chat, isAuditor && auditableVersion && /*#__PURE__*/(0, _jsxRuntime.jsx)(_index2.Button, {
        buttonType: "general-white-button circular-button",
        onClick: function onClick() {
          setCompare(function (current) {
            return !current;
          });
        },
        image: _IconoAB.default
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_index2.Button, {
        buttonType: "general-white-button close-button",
        onClick: function onClick() {
          window.location.href = "/products";
        }
      })]
    })]
  });
};

exports.HeaderTop = HeaderTop;